// Head over to the Credentials section in your app on CometChat Dashboard and where you can find your unqiue App ID, Region and Auth Key. 😊

type TCometChatConstants = {
  appId: string | undefined;
  region: string | undefined;
  authKey: string | undefined;
};

export const CometChatConstants: TCometChatConstants = {
  appId: process.env.REACT_APP_COMET_CHAT_APP_ID,
  region: process.env.REACT_APP_COMET_CHAT_REGION,
  authKey: process.env.REACT_APP_COMET_CHAT_AUTH_KEY
};
